export function selectIsSeekEnabled(state) {
  return !state.playback.isPlayingAds && state.playback.rights.seek
    // also seek is disabled while playing Dai ad and one of Forward/Rewind button is disabled
    && (!state.playback.isPlayingDaiAds
      || (state.playback.rights.adsRewind && state.playback.rights.adsFastForward));
}

function addDuration(interval) {
  const [start, stop] = interval;

  interval.push(Math.max(stop - start, 0));

  return interval;
}

// returns [start, stop, duration]
export function selectNormalizedInterval(state) {
  const {
    viewableMetadata,
    adsMetadata,
    streamDuration,
    isPlayingAds,
    isLive,
    seekRange,
  } = state.playback;

  if (isPlayingAds) {
    return addDuration([
      adsMetadata?.start || 0,
      adsMetadata?.stop || 0,
    ]);
  }

  if (!isLive) {
    // For VOD 'streamDuration', which comes from the manifest, tells us the exact
    // duration of the stream whereas 'start' and 'stop', which is part of the asset
    // metadata, can be several minutes wrong.
    return addDuration([0, streamDuration]);
  }

  // live stream
  const {
    start,
    stop,
  } = viewableMetadata;

  return addDuration([
    start === undefined ? seekRange.startAbsolute : start,
    stop === undefined ? seekRange.endAbsolute : stop,
  ]);
}

export function selectNormalizedCurrentTime(state) {
  const {
    playback: {
      isLive,
      currentTime,
      currentTimeAd,
      isPlayingAds,
    },
    controls: {
      seekMode,
      seekingTime,
    },
  } = state;

  if (isPlayingAds) return currentTimeAd;

  const [start] = selectNormalizedInterval(state);

  if (seekMode) {
    return isLive ? seekingTime - start : seekingTime;
  }

  if (isLive) {
    return currentTime > start ? currentTime - start : 0;
  }

  return currentTime;
}
